import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { Tag } from "models";

const component = "TagsDashboard";

export const TagsDashboardQueryKeys = {
  tags: backendQueryKey<Tag[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/tags/list" })
};
